import { render, staticRenderFns } from "./ChannelSettingsListView.vue?vue&type=template&id=731caa3c&scoped=true&"
import script from "./ChannelSettingsListView.vue?vue&type=script&lang=js&"
export * from "./ChannelSettingsListView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSettingsListView.vue?vue&type=style&index=0&id=731caa3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731caa3c",
  null
  
)

export default component.exports